import {DetailedHTMLProps, HTMLProps} from "react"
import {classNames} from "@/library/utilities/html"

export default function FormSection(props: DetailedHTMLProps<HTMLProps<HTMLDivElement>, HTMLDivElement>) {
    const {className = '', children, ...divProps} = props

    return <div {...divProps} className={classNames(
        "form-section", className
    )}>{children}</div>
}
